<template>
  <ModalComponent
    :model-value="showRef"
    :close="handleCloseModal"
    :max-width="60.0625"
    :style-class-contain="styleClassContain"
  >
    <ModalHeader
      style="z-index: 10"
      :class="`modal-header`"
      :title="getComponentUiText('app-more-info-modal-title-1')"
      @close="handleCloseModal"
    />
    <div class="tw-p-10 tw-flex tw-flex-col tw-gap-[25px]">
      <div class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]">
        <div class="tw-font-semibold tw-text-[#211F58]">
          Lorem ipsum dolor sit amet consectetur.
        </div>
        <div class="tw-font-normal">
          Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque
          ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu
          egestas amet dictumst dignissim. Molestie id semper morbi libero
          maecenas.
        </div>
      </div>
      <div class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]">
        <div class="tw-font-semibold tw-text-[#211F58]">
          Lorem ipsum dolor sit amet consectetur.
        </div>
        <div class="tw-font-normal">
          Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque
          ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu
          egestas amet dictumst dignissim. Molestie id semper morbi libero
          maecenas.
        </div>
      </div>
      <div class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[10px]">
        <div class="tw-font-semibold tw-text-[#211F58]">
          Lorem ipsum dolor sit amet consectetur.
        </div>
        <div class="tw-font-normal">
          Lorem ipsum dolor sit amet consectetur. Leo amet tincidunt ut quisque
          ut. A sit porttitor nibh sem rhoncus donec. Volutpat eget mi arcu
          egestas amet dictumst dignissim. Molestie id semper morbi libero
          maecenas.
        </div>
      </div>
      <div class="tw-text-right">
        <b-button
          variant="primary"
          class="tw-w-fit tw-shadow-none tw-bg-[#387DFF] tw-py-[7px] tw-px-[20px] tw-text-[13px] tw-font-medium tw-rounded-[27px]"
          type="submit"
          @click="handleCloseModal"
        >
          Close
        </b-button>
      </div>
    </div>
  </ModalComponent>
</template>

<script setup lang="ts">
import ModalHeader from "@/components/common/modalHeader.vue";
import { getComponentUiText } from "@/utils/utilities";
import { ref, watch } from "vue";
import ModalComponent from "../common/modalComponent.vue";

const props = defineProps({
  isMoreInfoModal: {
    type: Boolean,
    required: true,
  },
});

let showRef = ref(props.isMoreInfoModal);
let notInfoVisible = ref(true);

watch(
  () => props.isMoreInfoModal,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

const emit = defineEmits(["update:show"]);
const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

const styleClassContain = {
  "border-radius": "4px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};
</script>

<style lang="scss">
.assessment-modal {
  .button-verify.btn.btn-primary[disabled] {
    // background-color: #dbdbdb;
    background-color: red;
    color: #b7b7b7;
    border-color: #dbdbdb;
  }

  .button-verify {
    line-height: 100%;
    background-color: #387dff;
    border-color: #387dff;
  }
}

@media (max-width: 768px) {
  .assessment-modal {
    .modal-assessment,
    .modal-header {
      padding-right: 10px;
      padding-left: 10px;
    }
  }
}
</style>
